import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-29-ravi-panga-guest.webp";
import ThumbImg from "../../assets/images/conversations/029.webp";
import PlayIcon   from "../../assets/icons/conversations/play-icon.svg";
import PlayIcon2  from "../../assets/icons/conversations/play-icon-2.svg";
import ThumbImg2  from "../../assets/images/conversations/ep-29-ravi-panga-video2.webp";
import ThumbImg2Mobile from "../../assets/images/conversations/ep-29-ravi-panga-video2-mobile.webp";

/* ─────────────────────────────────────────────
   PREFIX: rp2-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .rp2-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .rp2-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  .rp2-hero { padding-top: 60px; padding-bottom: 60px; }
  .rp2-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .rp2-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .rp2-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .rp2-hero__title.rp2-visible { opacity: 1; transform: translateY(0); }
  .rp2-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .rp2-hero__spotify.rp2-visible { opacity: 1; transform: translateY(0); }
  .rp2-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .rp2-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .rp2-hero__right.rp2-visible { opacity: 1; transform: translateY(0); }

  .rp2-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .rp2-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .rp2-yt-thumb:hover img { opacity: 0.85; }
  .rp2-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .rp2-yt-thumb__play img { width: 40px; height: 44px; }
  .rp2-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .rp2-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  .rp2-body {
    padding-bottom: 60px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .rp2-body.rp2-visible { opacity: 1; transform: translateY(0); }
  .rp2-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .rp2-body__para:last-child { margin-bottom: 0; }

  .rp2-video2 {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .rp2-video2.rp2-visible { opacity: 1; transform: translateY(0); }
  .rp2-video2__wrap {
    position: relative; width: 100%; height: 500px;
    border-radius: 12px; overflow: hidden;
  }
  .rp2-video2__wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }
  .rp2-video2__thumb {
    position: relative; width: 100%; height: 500px;
    border-radius: 12px; overflow: hidden;
    cursor: pointer; display: block; background: #000;
  }
  .rp2-video2__thumb--desktop,
  .rp2-video2__thumb--mobile {
    width: 100%; height: 100%; object-fit: cover;
    display: block; border-radius: 12px;
    transition: opacity 0.3s ease;
  }
  .rp2-video2__thumb:hover .rp2-video2__thumb--desktop,
  .rp2-video2__thumb:hover .rp2-video2__thumb--mobile { opacity: 0.85; }
  .rp2-video2__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .rp2-video2__play img { width: 60px; height: 60px; }

  /* show/hide mobile thumbnail */
  .rp2-video2__thumb--desktop { display: block; }
  .rp2-video2__thumb--mobile  { display: none; }

  .rp2-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .rp2-guest.rp2-visible { opacity: 1; transform: translateY(0); }
  .rp2-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .rp2-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .rp2-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .rp2-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .rp2-inner { padding-left: 32px; padding-right: 32px; }
    .rp2-hero { padding-top: 32px; padding-bottom: 48px; }
    .rp2-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .rp2-hero__title { font-size: 24px; }
    .rp2-hero__left { gap: 16px; }
    .rp2-video2 { padding-bottom: 48px; }
    .rp2-video2__wrap { height: 350px; }
    .rp2-video2__thumb { height: 350px; }
    .rp2-video2__play img { width: 40px; height: 40px; }
    .rp2-guest__title { font-size: 24px; margin-bottom: 24px; }
    .rp2-guest__photo-bg { width: 260px; height: 300px; }
    .rp2-guest__name { font-size: 24px; margin-top: 18px; }
    .rp2-body__para { font-size: 14px; margin-bottom: 12px; }
    .rp2-body { padding-bottom: 48px; }
    .rp2-guest { padding-bottom: 48px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .rp2-inner { padding-left: 16px; padding-right: 16px; }
    .rp2-hero { padding-top: 51px; padding-bottom: 30px; }
    .rp2-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .rp2-hero__left { gap: 30px; }
    .rp2-hero__title { font-size: 30px; }
    .rp2-video2__wrap { height: 200px; }
    .rp2-video2__thumb { height: 200px; }
    .rp2-video2 { padding-bottom: 40px; }
    .rp2-video2__thumb--desktop { display: none; }
    .rp2-video2__thumb--mobile  { display: block; }
    .rp2-video2__play img { width: 30px; height: 30px; }
    .rp2-body__para { font-size: 16px; margin-bottom: 10px; }
    .rp2-guest__title { font-size: 30px; margin-bottom: 20px; text-align: left; }
    .rp2-guest__photo-bg { width: 100%; height: 386px; }
    .rp2-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .rp2-body { padding-bottom: 30px; }
    .rp2-guest { padding-bottom: 30px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("rp2-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const HERO_VIDEO_ID  = "aSMfrhO-7Yw";
const VIDEO2_ID      = "aSMfrhO-7Yw";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="rp2-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${HERO_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 29 Ravi Panga"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="rp2-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 29 Ravi Panga thumbnail" />
      <div className="rp2-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="rp2-hero">
      <div className="rp2-inner">
        <div className="rp2-hero__grid">
          <div className="rp2-hero__left">
            <h1 ref={titleRef} className="rp2-hero__title">
              EP 29 | Sustainable zero emission public transport for India | Ravi Panga | Causis Group Ltd
            </h1>
            <div ref={spotifyRef} className="rp2-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/6QMUpfzsvGvrGxMYLKGY28?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 29 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="rp2-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="rp2-body">
      <div className="rp2-inner">
        <p className="rp2-body__para">
          On 2nd January 2021, as the world was still grappling with the strict Corona lockdowns, limited flights and hotels being open, we at Energizing India had the opportunity to travel to Delhi to meet with Reji Pillai, President of India Smart Grid Forum. When we asked Reji what is the route to the quickest adoption of clean mobility in India, he responded with amazing clarity. A strong government policy focused on converting intra-city buses from ICE to fully electric. Reji suggested a government mandate and ban on new ICE buses for public transport, but in two years since that conversation, what has happened is classically Indian. There was no government ban and no overt government policy to change all public transport to fully electric in cities. But as everything beautiful and magical in India, it just started to happen.
        </p>
        <p className="rp2-body__para">
          Today most Indian megacities like Ahmedabad, Delhi, Bangalore, Chennai, Hyderabad, Pune, amongst others already run more than a hundred electric buses each as part of their public transport system. The miracle happened while the rest of the industry was tracking the launch of the Kia EV6, the Mercedes EQS and the Ather scooters. Quietly and all of a sudden people in the big cities of India are travelling in greater comfort. Air-conditioned buses that are safer and don't pollute the air while millions commute to and back from work every day.
        </p>
        <p className="rp2-body__para">
          So today we decided to focus on this public intracity bus sector, and we spoke with Ravi Panga, CEO of the Causis Group. A very interesting company that has acquired an electric bus tech company in Europe and whose electric bus operates in Kyrgyzstan, Mauritius, even in Qatar for the FIFA world cup and now the new Bombay double-decker electric bus that has us all so very excited.
        </p>
      </div>
    </section>
  );
}

function Video2Section() {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  useFadeUp(ref);
  return (
    <section ref={ref} className="rp2-video2">
      <div className="rp2-inner">
        {playing ? (
          <div className="rp2-video2__wrap">
            <iframe
              src={`https://www.youtube.com/embed/${VIDEO2_ID}?autoplay=1&rel=0`}
              title="EP 29 Ravi Panga Full Video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        ) : (
          <div className="rp2-video2__thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
            <img className="rp2-video2__thumb--desktop" src={ThumbImg2} alt="EP 29 Ravi Panga video" />
            <img className="rp2-video2__thumb--mobile" src={ThumbImg2Mobile} alt="EP 29 Ravi Panga video mobile" />
            <div className="rp2-video2__play">
              <img src={PlayIcon2} alt="Play" />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="rp2-guest">
      <div className="rp2-inner">
        <h2 className="rp2-guest__title">Our Guest</h2>
        <div>
          <div className="rp2-guest__photo-bg">
            <img src={GuestImg} alt="Ravi Panga" />
          </div>
          <p className="rp2-guest__name">Ravi PANGA</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep29RaviPanga() {
  return (
    <>
      <style>{CSS}</style>
      <div className="rp2-page">
        <HeroSection />
        <BodySection />
        
        <GuestSection />
      </div>
    </>
  );
}